import { Grid, Menu, Segment } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import { useLocation } from 'react-router';

import { ENV_PP, ENV_PROD, PREPROD_TABS, TABS } from '@/constants';
import { ModeReglementContextProvider, ProduitContextProvider } from '../Context';
import PictoBackground from './old/PictoBackground';
import ParametrageApplicationsSources from './ParametrageApplicationsSources';
import ParametrageModesReglement from './ParametrageModesReglement';
import ParametrageProduits from './ParametrageProduits';
import ParametrageQualite from './ParametrageQualite';

const Parametrage = () => {
  const { search } = useLocation() ?? {};

  // Deep-link : ?tab=produits pré-sélectionne l'onglet "Produits / Imputations comptables"
  // (utilisé par le bouton "Gérer les produits" de la Constitution de la régie).
  const initialTab = React.useMemo(() => {
    const tab = new URLSearchParams(search ?? '').get('tab');

    return tab === 'produits' ? TABS.PRODUITS : TABS.APPLICATIONS_SOURCES;
  }, [search]);

  const [activeItem, setActiveItem] = React.useState<TABS>(initialTab);
  // Compteur de click sur un onglet
  const [clicks, setClicks] = React.useState(0);

  const handleItemChange = React.useCallback(
    (e, { name }) => {
      setActiveItem(name);

      // si même onglet et si ctrl + clic, on incrémente le compteur
      if (activeItem === name && e.ctrlKey) {
        setClicks(clicks + 1);
      } else {
        setClicks(1);
      }
    },
    [activeItem, clicks],
  );

  return (
    <>
      {process.env.NODE_ENV === 'development' && <PictoBackground />}
      <Segment
        basic
        secondary
        style={{
          display: 'flex',
          height: '100%',
          margin: 0,
        }}
      >
        <Grid style={{ flex: 1 }}>
          <Grid.Row>
            <Grid.Column widescreen={3} largeScreen={4} computer={16} tablet={16} mobile={16}>
              <Menu vertical pointing style={{ width: '100%' }}>
                {_.map(ENV_PP || ENV_PROD ? PREPROD_TABS : TABS, (tab) => (
                  <Menu.Item
                    key={tab}
                    data-testid={tab}
                    name={tab}
                    active={activeItem === tab}
                    onClick={handleItemChange}
                  >
                    {tab}
                  </Menu.Item>
                ))}
              </Menu>
            </Grid.Column>
            <Grid.Column widescreen={13} largeScreen={12} computer={16} tablet={16} mobile={16}>
              <ProduitContextProvider type="parametrage">
                <ModeReglementContextProvider>
                  {activeItem === TABS.APPLICATIONS_SOURCES && <ParametrageApplicationsSources />}
                  {activeItem === TABS.PRODUITS && <ParametrageProduits />}
                  {activeItem === TABS.MODES_REGLEMENT && <ParametrageModesReglement />}
                  {activeItem === TABS.QUALITE && (
                    <ParametrageQualite
                      full={
                        clicks > 10 ||
                        process.env.NODE_ENV === 'development' ||
                        process.env.NODE_ENV === 'test'
                      }
                    />
                  )}
                </ModeReglementContextProvider>
              </ProduitContextProvider>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </>
  );
};

export default Parametrage;
